import { CabecalhoTela } from "./kit/CabecalhoTela";
import { Vazio } from "./kit/Estados";

export function EmConstrucao({ titulo, ticket, descricao }: { titulo: string; ticket: string; descricao: string }) {
  return (
    <div className="mx-auto max-w-3xl">
      <CabecalhoTela titulo={titulo} contexto={descricao} />
      <Vazio titulo="Esta tela está em construção">Ela chega com o ticket {ticket} do cronograma.</Vazio>
    </div>
  );
}
